// extracted by mini-css-extract-plugin
export default {"FilterBase":"FilterBase_FilterBase__c--FR","search":"FilterBase_search__q3jWh"};